/*=========================================================================================
  File Name: moduleCalendarGetters.js
  Description: Calendar Module Getters
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  categoryList(state) {
    const categoryList = state.categoryList
    const gradeId = state.activeGradeId
    const subjectTypeId = state.activeSubjectTypeId
    return categoryList.filter((item) => {
      if (gradeId && (!Array.isArray(item.grade_list) || !item.grade_list.includes(Number(gradeId)))) return false
      if (subjectTypeId && item.subject_type_id !== Number(subjectTypeId)) return false
      return true
    })
  },
  detailCategoryList(state) {
    const categoryList = state.categoryList
    const gradeId = state.activeGradeId
    const subjectTypeId = state.activeSubjectTypeId
    const subjectDetailTypeId = state.activeSubjectDetailTypeId
    return categoryList.filter((item) => {
      if (gradeId && (!Array.isArray(item.grade_list) || !item.grade_list.includes(Number(gradeId)))) return false
      if (subjectTypeId && item.subject_type_id !== Number(subjectTypeId)) return false
      if (
        subjectDetailTypeId != null &&
        typeof item.subject_detail_type_id !== 'undefined' &&
        item.subject_detail_type_id !== Number(subjectDetailTypeId)
      ) {
        return false
      }
      return true
    })
  },
}
